import { Base_Url } from '../../BaseUrl/BaseUrl';
import {
  getApiWithAuthorization,
  getApiWithoutAuthorization,
  patchApiWithAuthorization,
  postApiWithoutAuthorization,
  putApiWithoutAuthorization,
  putApiWithAuthorization,
  postApiWithAuthorization,
  deleteApiWithoutAuthorization,
} from '../ApiMethods/ApiMethods';

// Dynamically gets role based on login info
const getRole = () => {
  const storedLogin = JSON.parse(localStorage.getItem('login'));
  return storedLogin?.role?.includes('student') ? 'student' : 'seeker';
};

export const get_student_list = async params => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/filter`, params);
  return res;
};

export const get_student_delete = async params => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/delete`, params);
  return res;
};

export const get_student_manage_list = async params => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/manage`, params);
  return res;
};

export const get_student_details = async ID => {
  const res = await getApiWithAuthorization(`${Base_Url}/students/${ID}`);
  return res;
};

export const my_jobs_list = async params => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/${getRole()}/myjobs`, params);
  return res;
};

export const get_job_detail = async ID => {
  const storedLogin = JSON.parse(localStorage.getItem('login'));
  if (storedLogin?.role === 'employer') {
    return await getApiWithAuthorization(`${Base_Url}/employer/jobs/${ID}`);
  }
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/myjobs/${ID}`);
  return res;
};

export const get_my_jobs_list = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/myjobs`);
  return res;
};

export const my_Saved_jobs_list = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/saved-jobs`);
  return res;
};

export const my_Applied_jobs_list = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/applied-jobs`);
  return res;
};

export const get_search_student = async (searchParam, filter) => {
  let url = `${Base_Url}/students/search?q=${searchParam}`;
  if (filter !== null) {
    url += `&registered=${filter ? true : false}`;
  }
  const res = await getApiWithAuthorization(url);
  return res;
};

export const get_student_activity = async (ID, params) => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/${ID}/activity`, params);
  return res;
};

export const get_student_upload = async (ID, params) => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/upload`, params);
  return res;
};

export const get_student_edit = async (ID, params) => {
  const res = await putApiWithoutAuthorization(`${Base_Url}/students/${ID}/edit`, params);
  return res;
};

export const get_student_bulk_upload = async (ID, params) => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/bulk_upload`, params);
  return res;
};

export const resend_invites = async params => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/resend_invites`, params);
  return res;
};

export const send_leads = async params => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/students/send_leads`, params);
  return res;
};

export const get_student_leads = async (ID, params) => {
  const res = await postApiWithAuthorization(`${Base_Url}/students/${ID}/leads`, params);
  return res;
};

export const get_student_profile = async () => {
  const storedLogin = JSON.parse(localStorage.getItem('login'));
  if (storedLogin?.role === 'employer') {
    return await getApiWithAuthorization(`${Base_Url}/employer/profile`);
  }
  if (storedLogin?.role === 'admin') {
    return { profile: storedLogin.admin };
  }
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/profile`);
  return res;
};

export const get_save_job = async ID => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/myjobs/${ID}/save`);
  return res;
};

export const get_student_save = async (ID, params) => {
  const res = await putApiWithoutAuthorization(`${Base_Url}/${getRole()}/myjobs/${ID}/save`, params);
  return res;
};

export const mark_job_viewed = async ID => {
  const res = await putApiWithoutAuthorization(`${Base_Url}/${getRole()}/myjobs/${ID}/view`, {});
  return res;
};

export const get_list_filter = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/register/dropdowns`);
  return res;
};

// Company autocomplete options for the seeker dashboard filter.
export const get_company_suggestions = async query => {
  const q = typeof query === 'string' ? query.trim() : '';
  if (!q) return { companies: [] };
  return getApiWithAuthorization(`${Base_Url}/${getRole()}/myjobs/companies?q=${encodeURIComponent(q)}`);
};

export const get_list_filter_signup = async () => {
  const res = await getApiWithoutAuthorization(`${Base_Url}/${getRole()}/register/dropdowns`);
  return res;
};

export const resume_analysis = async JobID => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/myjobs/${JobID}/resume_analysis`);
  return res;
};

export const generate_resume = async (JobID, params) => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/${getRole()}/myjobs/${JobID}/generate_resume`, params);
  return res;
};

export const generate_cl = async (JobID, params) => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/${getRole()}/myjobs/${JobID}/generate_cl`, params);
  return res;
};

export const NextworkAPI = async JobID => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/${JobID}/networking`);
  return res;
};
export const linkedin_url_Api = async (ID, linkedin_url) => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/${ID}/networking-email?linkedin_url=${linkedin_url}`);
  // The API call is successful, but the component is getting `undefined`.
  // This ensures we always return the `data` object from the response if it exists.
  if (res?.data) {
    return res.data;
  }
  return res; // Fallback to returning the whole response if `data` is missing.
};

export const apply = async (JobID, data = {}) => {
  const res = await putApiWithoutAuthorization(`${Base_Url}/${getRole()}/myjobs/${JobID}/apply`, data);
  return res;
};

export const parse_resume = async formData => {
  const res = await postApiWithAuthorization(`${Base_Url}/${getRole()}/resume/parse`, formData);
  return res;
};

export const get_student_details_insight = async ID => {
  const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/insights`);
  return res;
};
export const get_student_details_insight_activity = async param => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/${getRole()}/insights/activity`, param);
  return res;
};
export const courses = async (JobID, params) => {
  const res = await postApiWithoutAuthorization(
    `${Base_Url}/${getRole()}/${JobID}/courses
`,
    params,
  );
  return res;
};

export const profile_Add_Update = async payload => {
  const res = await patchApiWithAuthorization(`${Base_Url}/${getRole()}/profile`, payload);
  return res;
};

// Application profiles stay in component memory; do not merge them into auth or persistent caches.
export const get_application_profile = async () => getApiWithAuthorization(`${Base_Url}/${getRole()}/application-profile`);

export const update_application_profile = async changes => patchApiWithAuthorization(
  `${Base_Url}/${getRole()}/application-profile`,
  { application_profile: changes },
);
// Employment reports: university students (student_registered) only; see docs/EMPLOYMENT_REPORTING_BACKEND_CONTRACT.md.
export const get_employment_report = async () => {
  return getApiWithAuthorization(`${Base_Url}/student/employment-report`);
};

export const save_employment_report = async report => {
  const body = { employment_report: report };
  return putApiWithAuthorization(`${Base_Url}/student/employment-report`, body);
};

// University admin (organization) views of their students' employment reports.
export const get_employment_reports = async ({ page = 1, page_size = 20, status = '', search = '' } = {}) => {
  const params = new URLSearchParams({ page: String(page), page_size: String(page_size) });
  if (status) params.set('status', status);
  if (search.trim()) params.set('search', search.trim());
  return getApiWithAuthorization(`${Base_Url}/students/employment-reports?${params.toString()}`);
};

export const get_student_employment_report = async studentId => {
  return getApiWithAuthorization(`${Base_Url}/students/${encodeURIComponent(studentId)}/employment-report`);
};

export const Password = async payload => {
  const res = await putApiWithoutAuthorization(`${Base_Url}/${getRole()}/password`, payload);
  return res;
};
export const get_resume_file = async () => {
  return await getApiWithAuthorization(`${Base_Url}/${getRole()}/resume/file`);
};

export const update_resume = async payload => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/${getRole()}/update_resume`, payload);
  return res;
};

export const upload_profile_photo = async data => {
  const role = getRole();
  let res;

  if (role === 'seeker') {
    res = await postApiWithAuthorization(`${Base_Url}/upload_profile_photo`, data);
  } else {
    res = await postApiWithAuthorization(`${Base_Url}/${role}/upload_profile_photo`, data);
  }

  return res;
};

export const deactivate_seeker = async () => {
  //
  const res = await deleteApiWithoutAuthorization(`${Base_Url}/seeker/deactivate`);
  // const res = await Utils.LoginResponse;

  return res;
};

export const newsletter_subscription = async payload => {
  const res = await postApiWithoutAuthorization(`${Base_Url}/get-newsletter`, payload);
  return res;
};

export const joblead_subscription = async payload => {
  const role = getRole();
  const res = await patchApiWithAuthorization(`${Base_Url}/${role}/toggle_subscribed`, payload);
  return res;
};
